import parsePhoneNumber from 'libphonenumber-js'

function formatPhoneNumber(string: string): string {
  const phoneNumber = string.trim();
  if (!phoneNumber.startsWith('+') && phoneNumber.length >= 12) {
    return `+${phoneNumber}`;
  }
  return phoneNumber;
}

// takes a full mobile number (eg: 91-1234567891) and returns only the phone number (1234567891)
export function extractPhoneNumber(string: string): string {
  if (!string) return ""
  const phoneNumber = formatPhoneNumber(string);
  const parsedNumber = parsePhoneNumber(phoneNumber);
  return parsedNumber?.nationalNumber ?? phoneNumber;
};

// takes a full mobile number (eg: 91-1234567891) and returns only the phone number (911234567891)
export const uiFormatPhoneNumber = (string: string) => {
  const phoneNumber = extractPhoneNumber(string);
  const countryCode = extractCountryCode(string);
  return `${countryCode}${phoneNumber}`.replace("+", "");
};

export const uiFormatPhoneNumberGroupBooking = (MobNumber: string) => {
  // Get the first two characters
  const firstTwoChars = MobNumber.substring(0, 2);
  // Get the rest of the phone number
  const restOfNumber = MobNumber.substring(2);
  // Combine them with a hyphen
  return `${firstTwoChars}-${restOfNumber}`;
};


// takes a full mobile number (eg: 91-1234567891) and returns only the country code (+91)
export function extractCountryCode(string: string): string {
  if (!string) return "+91"
  const phoneNumber = formatPhoneNumber(string);
  const parsedNumber = parsePhoneNumber(phoneNumber);
  const countryCode = parsedNumber?.countryCallingCode ? `+${parsedNumber?.countryCallingCode}` : "+91";
  return countryCode;
};